<mat-toolbar>
  <ng-container actions>
    <mat-toolbar-row>
      <ng-container class="mat-toolbar__left">
        <div
          class="flex--column spacing--margin-right item-selector"
          *ngIf="totalAmountOfDepartedChicks$ | async as totalAmountOfDepartedChicks"
        >
          {{ 'total' | translate }}: {{ totalAmountOfDepartedChicks | agrNumber }} ({{
            percentage$ | async | agrNumber
          }}% {{ 'of-delivery' | translate }})
        </div>
      </ng-container>

      <div class="mat-toolbar__right departure-actions">
        <ng-container *ngIf="slaughterReports$ | async as reports">
          <button
            *ngIf="reports.length > 0"
            mat-flat-button
            color="primary"
            (click)="import()"
            data-test="departure__import"
          >
            <mat-icon>import_export</mat-icon>{{ 'import' | translate }} ({{ reports.length }})
          </button>
        </ng-container>
        <button mat-flat-button color="accent" (click)="add()" data-test="departure__add">
          <mat-icon>add</mat-icon>{{ 'add' | translate }}
        </button>
        <label class="cdk-visually-hidden" for="departure-csv-input">
          {{ 'csv-import.upload' | translate }}
        </label>
        <input
          #departureCsvInput
          id="departure-csv-input"
          type="file"
          accept=".csv,text/csv"
          hidden
          (change)="uploadDepartureCsv($event)"
          data-test="departure__upload-csv-input"
        />
        <button
          mat-flat-button
          color="accent"
          (click)="departureCsvInput.click()"
          data-test="departure__upload-csv"
        >
          <mat-icon>upload_file</mat-icon>{{ 'csv-import.upload' | translate }}
        </button>
        <button
          mat-flat-button
          color="accent"
          (click)="downloadDepartureCsvTemplate()"
          data-test="departure__download-csv-template"
        >
          <mat-icon>file_download</mat-icon>{{ 'csv-import.download-template' | translate }}
        </button>
      </div>
    </mat-toolbar-row>
  </ng-container>
</mat-toolbar>

<ng-container [agrBlockSpinner]="(departures$ | async) === undefined">
  <ng-container *ngIf="departures$ | async as departures">
    <mat-nav-list *ngIf="departures.length > 0" class="departure__list">
      <a
        mat-list-item
        class="departure-item"
        data-test="departure__item"
        (click)="openDepartureEdit(departure.id)"
        *ngFor="let departure of departures"
      >
        <mat-icon matListItemAvatar class="list-avatar" svgIcon="mdi-inbox-arrow-down"></mat-icon>
        <div matListItemTitle>
          {{ departure.departureDate | agrDate: 'dd-MM-yyyy' }} -
          {{ departure.amountOfChicks | agrNumber }}
          {{ 'departure-item.type-' + departure.type.toString().toLowerCase() | translate }}
        </div>
        <div matListItemLine [attr.data-test]="'departure-item__barn-name--' + departure.barn.name">
          {{ 'departure.barn' | translate | titlecase }} {{ departure.barn.name }}
        </div>
        <div
          *ngIf="departure.linkedSlaughterReportId"
          matListItemLine
          data-test="departure-item__imported-label"
        >
          <i>{{ 'imported-slaughter-report-label' | translate }}</i>
        </div>
        <div matListItemMeta>
          <mat-slide-toggle
            [hideIcon]="true"
            style="padding-right: 30px"
            data-test="departure__toggle-showInFinalSetup"
            color="primary"
            labelPosition="before"
            [checked]="departure.showInFinalSetup !== false"
            (change)="onToggleShowInFinalSetup(departure, $event)"
            *ngIf="(isFinalSetupEnabled$ | async) && !departure.linkedSlaughterReportId"
          >
            <span class="text--small">{{ 'discount-showInFinalSetup' | translate }}</span>
          </mat-slide-toggle>

          @if (brandingService.isTenant('Agrifirm')) {
            <button mat-icon-button (click)="delete($event, departure.id)">
              <mat-icon>delete</mat-icon>
            </button>
          } @else {
            <button
              mat-flat-button
              class="tenant-icon-only-flat-button"
              color="primary"
              (click)="delete($event, departure.id)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>
      </a>
      <mat-divider></mat-divider>
    </mat-nav-list>

    <ng-container *ngIf="!departures.length">
      <agr-notification-empty
        [isEmpty]="(hasDayOldChicks$ | async) === false"
        [emptyTitle]="'departure.empty-day-old-chicks-title' | translate"
        [emptyDescription]="'departure.empty-day-old-chicks-description' | translate"
        emptyImage="assets/images/departure.jpg"
      >
      </agr-notification-empty>

      <agr-notification-empty
        [isEmpty]="(hasDayOldChicks$ | async) === true"
        [emptyTitle]="'departure.empty-title' | translate"
        [emptyDescription]="'departure.empty-description' | translate"
        emptyImage="assets/images/departure.jpg"
      >
      </agr-notification-empty>
    </ng-container>
  </ng-container>
</ng-container>
